
import { OptionReconductionDto } from "./OptionReconductionDto";


export class OptionFreeDto {
	
	statecode?: number = 1;
	statuscode?: number = 2;
	"resi_lotid@odata.bind"?: string;
	resi_source?: string = "Extranet";
	resi_idoption?: string;

}